export { TimelineSection } from './TimelineSection';
export type {
  AnnotationHorizontalAnchor,
  AnnotationPlacement,
  AnnotationSide,
  BandKind,
  BandSegment,
  TimelineHoverState,
  TimelineSectionProps,
  TimelineSectionEvent,
  TimelineSectionEventLabels,
  TimelineSectionAnnotationCopy,
  TimelineEventKind,
} from '@/types/timelineSection';
